export default __webpack_public_path__ + "static/media/zorba7.0b658202.jpg";